import { L3ServiceStatus } from './L3Service.model';
import { MaintenanceWork } from './MaintenanceWork.model';

export interface CustomerL3ServiceEventRegistration {
  customerId: number;
  eventRegistrationScopes: EventRegistrationScope[];
}

export interface NetworkServiceEventRegistration {
  networkServiceId: number;
  eventRegistrationScopes: EventRegistrationScope[];
}

export enum EventRegistrationScope {
  Status = 'STATUS',
  Notification = 'NOTIFICATION',
  Maintenance = 'MAINTENANCE'
}

export interface NetworkServiceUpdateEvent {
  networkServiceId: number;
  scopeUpdates: NetworkServiceScopeUpdate[];
}

export type NetworkServiceScopeUpdate = {
  scope: EventRegistrationScope;
  content: NotificationUpdate | StatusUpdate | MaintenanceUpdate;
};


export interface StatusUpdate {
  status: L3ServiceStatus
}

export interface NotificationUpdate {
  count: number
}

export interface MaintenanceUpdate {
  maintenanceWorks: MaintenanceWork[];
}